// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { ILevelGeneralDto } from 'src/app/infrastructure/models/level-general-dto';
import { IDomainData, domainData } from 'src/app/features/domain/models/domain-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { ICountryDto } from './country-dto.g';
import { ILogosDto } from './logos-dto.g';
import { IImageBoxDto } from './image-box-dto.g';
import { IUserDto } from './user-dto.g';

export const domainDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    appSubTitle: 'appSubTitle',
    description: 'description',
    streetNr: 'streetNr',
    postalCode: 'postalCode',
    town: 'town',
    county: 'county',
    countryCode: 'countryCode',
    timeZoneId: 'timeZoneId',
    address: 'address',
    pcTown: 'pcTown',
    deleted: 'deleted',
    inactive: 'inactive',
    requireTwoFactor: 'requireTwoFactor',
    billingState: 'billingState',
    requireTwoFactorFrom: 'requireTwoFactorFrom',
    formerMembersReadOnly: 'formerMembersReadOnly',
    ownerDto: 'ownerDto',
    logosDto: 'logosDto',
    photoBoxDto: 'photoBoxDto',
    countryDto: 'countryDto',
} as const;

export type TDomainDto = (typeof domainDto)[keyof typeof domainDto];

export const domainDtoConstraints = {
    name: { maxLength: 40, minLength: 1 },
    appSubTitle: { maxLength: 40 },
    streetNr: { maxLength: 50 },
    postalCode: { maxLength: 10 },
    town: { maxLength: 30 },
    countryCode: { required: true },
} as const;

export type TDomainDtoConstraints = typeof domainDtoConstraints;

export interface IDomainDto extends ILevelGeneralDto {
    [domainDto.guid]: string | null;
    [domainDto.nr]: number | null;
    [domainDto.name]: string | null;
    [domainDto.appSubTitle]: string | null;
    [domainDto.description]: string | null;
    [domainDto.streetNr]: string | null;
    [domainDto.postalCode]: string | null;
    [domainDto.town]: string | null;
    [domainDto.county]: string | null;
    [domainDto.countryCode]: string | null;
    [domainDto.timeZoneId]: string | null;
    [domainDto.address]: string | null;
    [domainDto.pcTown]: string | null;
    [domainDto.deleted]: boolean | null;
    [domainDto.inactive]: boolean | null;
    [domainDto.requireTwoFactor]: boolean | null;
    [domainDto.billingState]: string | null;
    [domainDto.requireTwoFactorFrom]: string | null;
    [domainDto.formerMembersReadOnly]: boolean | null;
    [domainDto.ownerDto]: IUserDto | null;
    [domainDto.logosDto]: ILogosDto | null;
    [domainDto.photoBoxDto]: IImageBoxDto | null;
    [domainDto.countryDto]: ICountryDto | null;
}

export class DomainDto
    implements IDomainDto
{
    [domainDto.guid]: string | null = null;
    [domainDto.nr]: number | null = null;
    [domainDto.name]: string | null = null;
    [domainDto.appSubTitle]: string | null = null;
    [domainDto.description]: string | null = null;
    [domainDto.streetNr]: string | null = null;
    [domainDto.postalCode]: string | null = null;
    [domainDto.town]: string | null = null;
    [domainDto.county]: string | null = null;
    [domainDto.countryCode]: string | null = null;
    [domainDto.timeZoneId]: string | null = null;
    [domainDto.address]: string | null = null;
    [domainDto.pcTown]: string | null = null;
    [domainDto.deleted]: boolean | null = null;
    [domainDto.inactive]: boolean | null = null;
    [domainDto.requireTwoFactor]: boolean | null = null;
    [domainDto.billingState]: string | null = null;
    [domainDto.requireTwoFactorFrom]: string | null = null;
    [domainDto.formerMembersReadOnly]: boolean | null = null;
    [domainDto.ownerDto]: IUserDto | null = null;
    [domainDto.logosDto]: ILogosDto | null = null;
    [domainDto.photoBoxDto]: IImageBoxDto | null = null;
    [domainDto.countryDto]: ICountryDto | null = null;

    private constructor(modelData?: IDomainData | null)
    {
        if (!modelData || isEmptyObject(modelData)) return;

        this[domainDto.guid] = modelData[domainData.guid];
        this[domainDto.nr] = modelData[domainData.nr] ?? null;
        this[domainDto.name] = modelData[domainData.name];
        this[domainDto.address] = modelData[domainData.address] ?? null;
        this[domainDto.streetNr] = modelData[domainData.streetNr] ?? null;
        this[domainDto.postalCode] = modelData[domainData.postalCode] ?? null;
        this[domainDto.town] = modelData[domainData.town] ?? null;
        this[domainDto.county] = modelData[domainData.county] ?? null;
        this[domainDto.countryCode] = modelData[domainData.countryCode];
        this[domainDto.timeZoneId] = modelData[domainData.timeZoneId] ?? null;
        this[domainDto.appSubTitle] = modelData[domainData.subTitle] ?? null;
        this[domainDto.description] = modelData[domainData.description] ?? null;
        this[domainDto.deleted] = modelData[domainData.deleted];
        this[domainDto.inactive] = modelData[domainData.inactive];
    }

    static create(formData?: IDomainData | null): DomainDto | null {
        return formData ? new DomainDto(formData) : null;
    }
}
